import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { pageMetadata, companyInfo } from '../data';

export default function AboutPage() {
  useEffect(() => {
    // Set page title and meta description
    document.title = pageMetadata.about.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', pageMetadata.about.description);
  }, []);

  return (
    <div className="space-y-24 pb-24">
      {/* Page Header / Hero */}
      <section className="relative overflow-hidden py-20 bg-gradient-to-b from-brand-sand/20 to-brand-cream border-b border-brand-sand">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6 relative z-10">
          <span className="text-brand-green text-xs font-semibold tracking-widest uppercase font-sans">Mød Johanne</span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-brand-dark tracking-wide font-display">
            Om Johanne Eis
          </h1>
          <p className="font-display text-xl sm:text-2xl text-brand-green italic leading-relaxed max-w-3xl mx-auto">
            “ Min største lektie her i livet har været i træde ind i mit lys og lade mig være centrum for mit liv. ”
          </p>
        </div>
      </section>

      {/* Main Story Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Column: Image */}
          <div className="lg:col-span-5 relative">
            <div className="absolute inset-0 bg-brand-green/5 rounded-3xl transform -rotate-3 scale-105" />
            <div className="relative aspect-[3/4] rounded-3xl overflow-hidden shadow-xl border border-brand-sand">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/9c094138-0bed-486b-b914-79750263377d/25-johanne-eis-1080x1920-5-1.webp"
                alt="Johanne Eis"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right Column: Text */}
          <div className="lg:col-span-7 space-y-8 text-left">
            <h2 className="text-3xl sm:text-4xl text-brand-dark tracking-wide">Min baggrund</h2>
            <div className="space-y-6 text-brand-muted font-sans text-base sm:text-lg leading-relaxed">
              <p>
                At lære at være glad for at være det menneske jeg er i alle livets sammenhænge. Det betød at jeg skulle stå ud af overlevelse og ind i det livfulde liv.
              </p>
              <p>
                I dag er jeg vild med at skabe bevidsthed om hvordan jeg har det, og hvordan jeg ønsker mit liv. Når jeg kender mit udgangspunkt, er det let at skabe forandring igennem healing og transformation, til den tilstand jeg ønsker.
              </p>
              <p>
                Sådan har det ikke altid været. Meget i mit liv har foregået ubevidst da jeg lå i overhalingsbanen på motorvejen for overlevelse. Endda ret ubevidst.
              </p>
              <p>
                En hård skilsmisse, satte gang i en voldsom retraumatisering og en gigantisk opvågning og i dag tør jeg godt sige at jeg elsker at leve og folde mig ud.
              </p>
              <p className="font-medium text-brand-dark">
                At stå rent som en lysende bevidsthed, det er jeg dedikeret til helt ned i mindste detalje – jeg elsker at se folk træde ind i deres lys og tage skridt til at stå i deres egen kraft.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quote / Philosophy Section */}
      <section className="bg-brand-sand/30 py-16 border-y border-brand-sand">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <i className="fa-light fa-quote-left text-brand-green/30 text-5xl" />
          <p className="font-display text-2xl sm:text-3xl text-brand-dark leading-relaxed">
            Gennem ceremonier og levende nærvær åbnes et felt, hvor den ægte, sande dig får plads. Hvor du møder dig selv fra sjæl i sandhed, med blidhed og samtidig enorm kraftfuld styrke.
          </p>
          <div className="w-12 h-[1px] bg-brand-green mx-auto my-4" />
          <span className="block font-sans text-xs uppercase tracking-widest text-brand-green font-semibold">
            Johanne Eis · Spirituel Livsskabelse
          </span>
        </div>
      </section>

      {/* Call to Action to Events */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
        <h2 className="text-3xl sm:text-4xl text-brand-dark tracking-wide">Oplev feltet i fællesskab</h2>
        <p className="text-brand-muted font-sans text-base sm:text-lg leading-relaxed max-w-2xl mx-auto">
          Jeg inviterer dig til at deltage i mine kommende events, ceremonier og cirkler. Det er her, vi sammen åbner for transformationen og lader livskraften flyde frit.
        </p>
        <div className="flex justify-center gap-4">
          <Link
            to="/events"
            className="bg-brand-green hover:bg-brand-green/90 text-brand-cream px-8 py-4 rounded-full text-base font-medium tracking-wide transition-all duration-300 shadow-sm"
          >
            Se kommende events
          </Link>
          <Link
            to="/kontakt"
            className="bg-brand-cream hover:bg-brand-sand border border-brand-beige text-brand-dark px-8 py-4 rounded-full text-base font-medium tracking-wide transition-all duration-300 shadow-sm"
          >
            Kontakt mig
          </Link>
        </div>
      </section>
    </div>
  );
}
